import { render, staticRenderFns } from "./DeleteSplashScreen.vue?vue&type=template&id=eae4d00a&"
import script from "./DeleteSplashScreen.vue?vue&type=script&lang=js&"
export * from "./DeleteSplashScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports